import Entity from "/src/js/engine/entity";
import SimplexNoise from "simplex-noise";

export default class Particle extends Entity{
    constructor({engine, position}){
        super({engine,type:"fx"});
        this.zindex = -1;
        this.engine = engine;
        this.position = {...position};
        this.lifetime = 2;
        this.currentLifetime = this.lifetime;
        this.noise = new SimplexNoise();
        this.size = Math.random() * 5 + 10;
        this.rotation = Math.random() * Math.PI * 2;
    }

    update(){
        const s = this.engine.scaleFactor;
        this.position.x += (this.noise.noise2D(0,this.engine.time.time * 0.2) * 50 - 300) * this.engine.time.delta;
        this.position.y += this.noise.noise2D(this.engine.time.time * 0.2, 0) * 50 * this.engine.time.delta;
        this.currentLifetime -= this.engine.time.delta;
        if(this.currentLifetime <= 0){
            this.engine.destroyEntity(this);
        }
    }

    render(ctx){
        const s = this.engine.scaleFactor;
        const w = this.size * s;
        const r = this.currentLifetime/this.lifetime;

        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.scale(r,r);
        ctx.rotate(this.rotation);
        ctx.strokeStyle = "red";
        ctx.globalAlpha = r * 0.5;
        ctx.beginPath();
        ctx.arc( 0, 0, w, 2 * Math.PI, false);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.restore();
    }
}